import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleBtn", "downloadBtn", "count"]

  connect() {
    this.updateCount()
  }

  get checkboxes() {
    return this.element.querySelectorAll('input[type="checkbox"][name="document_ids[]"]')
  }

  get checkedCount() {
    return Array.from(this.checkboxes).filter(cb => cb.checked).length
  }

  get allChecked() {
    return this.checkboxes.length > 0 && this.checkedCount === this.checkboxes.length
  }

  toggleAll(event) {
    event.preventDefault()
    const shouldCheck = !this.allChecked

    this.checkboxes.forEach(cb => {
      cb.checked = shouldCheck
    })

    this.updateCount()
  }

  updateCount() {
    const count = this.checkedCount

    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }

    if (this.hasDownloadBtnTarget) {
      this.downloadBtnTarget.disabled = count === 0
    }

    if (this.hasToggleBtnTarget) {
      this.toggleBtnTarget.textContent = this.allChecked ? "Tout désélectionner" : "Tout sélectionner"
    }
  }
}
